import { useState, useCallback, type ReactNode } from "react";
import { Snackbar, type SnackbarType } from "../components/Snackbar";
import { SnackbarContext } from "./snackbarContextDef";

interface SnackbarMessage {
  id: number;
  message: string;
  type: SnackbarType;
  duration?: number;
}

let snackbarId = 0;

export function SnackbarProvider({ children }: { children: ReactNode }) {
  const [snackbars, setSnackbars] = useState<SnackbarMessage[]>([]);

  const showSnackbar = useCallback(
    (message: string, type: SnackbarType = "info", duration = 5000) => {
      const id = ++snackbarId;
      setSnackbars((prev) => [...prev, { id, message, type, duration }]);
    },
    [],
  );

  const removeSnackbar = useCallback((id: number) => {
    setSnackbars((prev) => prev.filter((s) => s.id !== id));
  }, []);

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      {snackbars.map((snackbar) => (
        <Snackbar
          key={snackbar.id}
          message={snackbar.message}
          type={snackbar.type}
          duration={snackbar.duration}
          onClose={() => removeSnackbar(snackbar.id)}
        />
      ))}
    </SnackbarContext.Provider>
  );
}
